// src/components/MainContent.tsx
import { Box, Container, Grid, } from "@mui/material";
import PromoRightForm from "./PromoRightForm";

const MainContent: React.FC = () => {
    return (
        <Container
            maxWidth="xl" // ✅ use responsive container size (sm, md, lg, xl)
            sx={{
                py: 6,
                position: "relative",
                zIndex: 2,
                overflowX: "hidden",
            }}
        >
            <Grid container spacing={0} alignItems="center" justifyContent="center">
                {/*  left */}
                <Grid size={{ xs: 12, md: 6 }} sx={{ display: { xs: "none", md: "block" } }}>
                    <Box
                        component="img"
                        src="/imgs/GIFT.webp"
                        alt="Gift"
                        draggable="false"
                        sx={{
                            width: "100%",
                            height: "auto",
                            display: "block",
                            borderRadius: 2,
                        }}
                    />
                </Grid>
                {/* Rigth */}
                <Grid size={{ xs: 12, md: 6 }}
                    sx={{
                        mt: { xs: 0, md: 0 },
                    }}>
                    <PromoRightForm />
                </Grid>
            </Grid>
        </Container>
    );
};

export default MainContent;
